"use client";

import { useCallback, useMemo } from "react";
import { useGlobalStateContext } from "@/context/GlobalContext";
import {
  getStoredRoleBasedAccessPermissions,
  hasFeaturePermission,
} from "@/utils/roleBasedAccessHelper";

export function usePermissions(featureId: number | string, permissionRule?: () => boolean) {
  const { roleBasedAccessPermissions } = useGlobalStateContext();

  const permissions = useMemo(() => {
    if (Object.keys(roleBasedAccessPermissions).length > 0) {
      return roleBasedAccessPermissions;
    }
    return getStoredRoleBasedAccessPermissions();
  }, [roleBasedAccessPermissions]);

  const accessMap = useMemo(
    () => permissions[featureId.toString()]?.accessMap ?? {},
    [permissions, featureId]
  );

  const hasPermission = useCallback(
    (accessKeys: readonly string[], customRule?: () => boolean) => {
      if (permissionRule && typeof permissionRule === "function" && permissionRule()) {
        return true;
      }
      if (customRule && typeof customRule === "function" && customRule()) {
        return true;
      }
      return hasFeaturePermission(permissions, featureId, accessKeys);
    },
    [permissions, featureId]
  );

  return {
    hasPermission,
    accessMap,
  };
}
